import * as Yup from 'yup';
import { DayOfWeek } from 'components/Types/Tenant/shop.type';

const contactLocationSchema = Yup.object({
  contactNumber: Yup.string().required('Contact number is required'),
  streetAddress: Yup.string().required('Street address is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  country: Yup.string().required('Country is required'),
  zipCode: Yup.string(),
});

const socialLinksSchema = Yup.array().of(
  Yup.object({
    platform: Yup.string().required('Required'),
    url: Yup.string().required('Required').url('Invalid URL'),
  }),
);

const businessHoursSchema = Yup.array().of(
  Yup.object({
    day: Yup.mixed<DayOfWeek>().required('Required'),
    openTime: Yup.string().when('isClosed', {
      is: false,
      then: (schema) => schema.required('Required'),
    }),
    closeTime: Yup.string().when('isClosed', {
      is: false,
      then: (schema) => schema.required('Required'),
    }),
    isClosed: Yup.boolean().required(),
  }),
);

export const shopValidationSchema = Yup.object({
  name: Yup.string().required('Required'),
  slug: Yup.string().required('Required'),
  notificationEmail: Yup.string()
    .email('Invalid email')
    .when('enableNotification', {
      is: true,
      then: (schema) =>
        schema.required('Notification email is required when notifications are enabled'),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  enableNotification: Yup.boolean(),
  description: Yup.string(),
  logoUrl: Yup.string().url('Invalid URL'),
  coverImageUrl: Yup.string().url('Invalid URL'),
  metaDescription: Yup.string(),
  metaKeywords: Yup.string(),
  isActive: Yup.boolean(),
  ...contactLocationSchema.fields,
  socialProfiles: socialLinksSchema,
  businessHours: businessHoursSchema,
});
